// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9782 ? "39811124" : chunkId) + "." + {"2958":"84604742f350d423","7939":"921913c909eeb4b3","8096":"d55cd24b87d00fe9","8888":"aa1ddf527e607c4e","9782":"0201f3056de6c3bd"}[chunkId] + ".js";
};